import React, {useEffect, useState} from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import CitaForm from "./CitaForm";

const CitaEdit = () => {

  const navigate = useNavigate()

  const {id,idConsejeria} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/cita-consejeria/' + id, {});

  const [formatedData,setFormatedData] = useState(null)

  useEffect(()=>{
    if(data && data.fechaCita){
      setFormatedData({...data,
        fechaCita: data.fechaCita,
        idConsejeria: idConsejeria,
      })
    }
  },[data])

  const onUpdate = (cita) => {
    if(cita.selectedFechaCita && cita.selectedConsejeroConsejeriaId){
      const auxCita = data;
      auxCita.fechaCita = cita.selectedFechaCita + "-05:00"
      auxCita.consejeroConsejeriaId = cita.selectedConsejeroConsejeriaId
      axios.put(Apis.PROD + '/cita-consejeria/update/' + id, auxCita)
        .then(res => {
          successToast("Cita actualizada correctamente")
          navigate('/citas')
        })
        .catch(err => {
          errorToast(err.response.data.message, 6000)
        });
    }
    else  errorToast("Seleccione un consejero y fecha/hora valida", 6000)
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Citas' onClick={() => navigate('/citas')}/>
        <PageTitle title={'Mover cita de consejeria'}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <CitaForm value={formatedData} onSubmit={(cita) => onUpdate(cita)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default CitaEdit;
